<template>
  <div class="ab_opponent">
    <HaPosition :position="spot.position" />
    <HaAction
      :showBetsIn="showBetsIn"
      :spot="spot"
      :action="spot.selected_action"
    />
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import HaAction from '@/components/AnalyzeStreetBlocks/HaAction'
import HaPosition from '@/components/AnalyzeStreetBlocks/HaPosition'

export default {
  name: 'HaOpponent',

  components: {
    HaAction,
    HaPosition,
  },
  mixins: [format_mix],
  props: {
    spot: Object,
    showBetsIn: String,
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.ab {
  &_opponent {
    display: flex;
  }
}
</style>
